import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "GoogleSuiteModule"
const debug = false

export class GoogleSuiteModule extends ModuleProto {

    private installLink     : string    = "https://gsuite.google.com/marketplace/app/goodday/588823826282"

    public accounts    : any[]
    public domain      : string | undefined

    constructor() {
        super(ModuleType.GOOGLE_SUITE, {});

        debug && console.log(debug, "constructor() moduleConfig= ??? ")

        this.name                       = "Google Workspace"
        this.description                = "Connect to your corporate Google account to enable an automatic login with Google to GoodDay for all team members."
        this.svgIcon                    = "isvg-gsuite"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.INTEGRATIONS
        this.settingsUrl                = 'settings/integrations/gsuite'
        this.parentSection              = SettingsParentSection.INTEGRATIONS

        this.typeLabel                  = "Integrations"

        this.accounts                   = []
        this.domain                     = undefined
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    enable() {
        gd.openInNewWindow(this.installLink)
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
